import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useTrack } from '../track';
import { GET_TRACK_RECORD } from './queries';
import { TrackRecord, type TrackRecordData } from './components';

/**
 * "Our track record": the ten tiles with the 7-day / 1-month switch, loading
 * their own figures. The signed-in home and a brand's landing page both use it,
 * so the tiles match wherever they appear. The figures are public.
 */
export function TrackRecordSection({ analysisTypeId = 1, skip = false }: { analysisTypeId?: number; skip?: boolean }) {
  const track = useTrack();
  const [period, setPeriod] = useState<'7_DAYS' | '1_MONTH'>('1_MONTH');
  const q = useQuery<TrackRecordData>(GET_TRACK_RECORD, { variables: { analysisTypeId, timePeriod: period }, errorPolicy: 'all', skip });
  return (
    <TrackRecord
      data={q.data}
      period={period}
      onPeriod={(p) => {
        setPeriod(p);
        track('ui_toggle', { control: 'track_record_period', value: p });
      }}
    />
  );
}
